import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { useContext } from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'
import { Role } from '../../../enum'
import { Context } from '../../../providers/ProjectContextProvider'
import PaginatedResPagination from '../../Pagination/PaginatedResPagination'
import ProjectRow from './ProjectRow'

interface Props {
  projects: Project[]
  handleDeleteClick: (project: Project) => void
  handleEditViewClick: (project: Project) => void
  handleArchiveClick: (project: Project) => void
  rowsPerPage: number
  setRowsPerPage: (rowsPerPage: number) => void
  page: number
  setPage: (page: number) => void
}

const ProjectTable = ({
  projects,
  handleEditViewClick,
  handleDeleteClick,
  handleArchiveClick,
  rowsPerPage,
  setRowsPerPage,
  page,
  setPage,
}: Props) => {
  const { userInfo } = useSelector(
    (state: { userLogin: UserLogin }) => state.userLogin
  )
  const { totalProjects } = useSelector(
    (state: RootStateOrAny) => state.allProjectList
  )

  const { selectedProjects, setSelectedProjects } = useContext(Context)

  const handleRowSelect = (project: Project, isSelected: boolean) => {
    let newSelected: Project[]

    if (isSelected) {
      newSelected = [...selectedProjects, project]
    } else {
      newSelected = selectedProjects.filter((x) => x._id !== project._id)
    }
    setSelectedProjects(newSelected)
  }

  // Toggle all rows selection
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = projects.map((project) => project)
      setSelectedProjects(newSelecteds)

      return
    }
    setSelectedProjects([])
  }

  // Check if all rows are selected
  const isAllSelected = projects.length === selectedProjects.length

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              {userInfo.isAdmin ? (
                <>
                  {userInfo.role === Role.MANAGER && (
                    <TableCell padding="checkbox">
                      <Checkbox
                        indeterminate={
                          selectedProjects.length > 0 &&
                          selectedProjects.length < projects.length
                        }
                        checked={isAllSelected}
                        onChange={handleSelectAllClick}
                      />
                    </TableCell>
                  )}
                  <TableCell>Name</TableCell>
                  <TableCell>Client</TableCell>
                  <TableCell>Company</TableCell>
                  <TableCell>Location</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Assignee</TableCell>
                  <TableCell>Created</TableCell>
                  <TableCell>Last updated</TableCell>
                  <TableCell></TableCell>
                </>
              ) : (
                <>
                  <TableCell>Name</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Date added</TableCell>
                  <TableCell>Last updated</TableCell>
                  <TableCell></TableCell>
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {projects.map((project, index) => {
              const hideFromUser =
                project.archiveReason === 'User archived project' &&
                !userInfo.isAdmin
              if (!hideFromUser) {
                return (
                  <ProjectRow
                    key={index}
                    project={project}
                    handleEditViewClick={handleEditViewClick}
                    handleDeleteClick={handleDeleteClick}
                    handleArchiveClick={handleArchiveClick}
                    onToggleSelect={handleRowSelect}
                    isSelected={selectedProjects.includes(project)}
                  />
                )
              } else {
                return null
              }
            })}
          </TableBody>
        </Table>

        <PaginatedResPagination
          setRowsPerPage={setRowsPerPage}
          rowsPerPage={rowsPerPage}
          page={page}
          setPage={setPage}
          rows={totalProjects}
        />
      </TableContainer>
    </>
  )
}

export default ProjectTable
